import React from 'react';
import I18n from 'i18n-js';
import gql from 'graphql-tag';
import { graphql, ChildProps } from 'react-apollo';

import CSPRow, { CSPCardFragment } from '@reverbdotcom/commons/src/components/csp_row';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';

import { CoreRecentlyViewedCspsRow } from '../schemas/rql';
import { compact, uniqBy } from 'lodash';
interface IProps {
  alwaysRender?: boolean;
}

export function RecentlyViewedCspsRow(props: ChildProps<IUserContext & IProps, CoreRecentlyViewedCspsRow.Query>) {
  const loading = !!props.data?.loading;
  const csps = compact(props.data?.recentlyViewedListings?.map(listing => listing.csp));

  const recentlyViewedCsps = uniqBy(csps, (csp) => csp.id);

  if (!props.alwaysRender) { return null; }

  return (
    <CSPRow
      title={I18n.t('discovery.item2RecentlyViewedCsps.title')}
      csps={recentlyViewedCsps}
      loading={loading}
    />
  );
}

const withQuery = graphql<IUserContext, CoreRecentlyViewedCspsRow.Query>(
  gql`
    query Core_RecentlyViewedCspsRow {
      recentlyViewedListings(input: { limit: 25 }) {
        _id
        csp {
          _id
          ...CSPCard
        }
      }
    },
    ${CSPCardFragment},
  `,
  {
    options: () => {
      return {
        ssr: false,
        variables: {},
      };
    },
    skip: (ownProps) => !!ownProps.user?.loggedOut,
  },
);

export default withUserContext<IUserContext & IProps>(withQuery(RecentlyViewedCspsRow));
